import React, { useState } from 'react';
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  IconButton,
  Button,
  Tooltip,
  CardActions
} from '@mui/material';
import {
  Star,
  StarBorder,
  Share,
  CalendarToday,
  Euro,
  Group,
  Person,
  LocationOn
} from '@mui/icons-material';
import './MissionCard.css';
import MissionDetailsModal from './MissionDetailsModal';


const MissionCard = ({
  mission,
  isFavorite,
  onToggleFavorite,
  onShare,
  onView
}) => {
  const [showModal, setShowModal] = useState(false);

  const [logoError, setLogoError] = useState(false);
  const logoUrl = mission.logoUrl
    ? `${process.env.REACT_APP_API_BASE_URL}${mission.logoUrl}`
    : '';
  const fallbackInitial = mission.company?.charAt(0)?.toUpperCase() || 'E';
  const devise = mission.devise || '€'; // peut être €, MAD, TND

  return (
    <Card className={`mission-modern-card ${isFavorite ? 'fav-bg' : ''}`}>
      <div className="card-header-top">
        <div className="logo-wrapper-with-name">
          <div className="logo-wrapper">
            {!logoError && logoUrl ? (
              <img
                src={logoUrl}
                alt="logo"
                className="mission-logo"
                onError={() => setLogoError(true)}
              />
            ) : (
              <Avatar className="logo-fallback">{fallbackInitial}</Avatar>
            )}
            {mission.isNew && <span className="badge-new">NOUVEAU</span>}
          </div>
          <Typography className="company-name">{mission.company}</Typography>
        </div>

        <div className="icons-top">
          <Tooltip title="Partager">
            <IconButton onClick={() => onShare(mission)}>
              <Share />
            </IconButton>
          </Tooltip>
          <Tooltip title={isFavorite ? 'Retirer des favoris' : 'Ajouter aux favoris'}>
            <IconButton onClick={() => onToggleFavorite(mission._id)}>
              {isFavorite ? <Star color="warning" /> : <StarBorder />}
            </IconButton>
          </Tooltip>
        </div>
      </div>

      <CardContent className="mission-content">
  <Typography className="mission-title">{mission.title}</Typography>


  {/* Bloc informations avec marge */}
  <div className="mission-infos-wrapper">
    <div className="mission-infos">
      <p>
        <CalendarToday className="icon" /> Publiée le :{' '}
        <strong>{mission.date}</strong>
      </p>
      <p>
        <Euro className="icon" /> Prime : <strong>{mission.reward} {devise}</strong>
      </p>
      <p className="mission-location">
        <LocationOn className="icon" /> Localisation :{" "}
        <strong>
          {(mission.location?.length > 25 ? mission.location.slice(0, 25) + "..." : mission.location) || "Ville inconnue"}
        </strong>
      </p>
      <p>
        <Group className="icon" /> {mission.availableSpots || 0} profil(s) recherché(s)
      </p>
      <p>
        <Person className="icon" /> {mission.candidates || 0} candidat(s)
      </p>

    </div>
  </div>
</CardContent>


<CardActions className="mission-card-actions">
 
  <Button
    variant="contained"
    color="primary"
    className="mission-btn"
    onClick={() => onView(mission._id)}
  >
    Voir la mission
  </Button>

  <MissionDetailsModal
    open={showModal}
    onClose={() => setShowModal(false)}
    mission={mission}
  />

   <Button
    variant="outlined"
    onClick={() => setShowModal(true)}
  >
    Détails
  </Button>
</CardActions>


<MissionDetailsModal
  open={showModal}
  onClose={() => setShowModal(false)}
  mission={mission}
/>

    </Card>
  );
};

export default MissionCard;
